import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {WorkspaceId} from "@/sdk";
import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";

export const ACCOUNT_CREDITS_ROUTE_NAME = 'account_credits';

export function isAccountCreditsRoute(router: Router): boolean {
  return router.currentRoute.value.name === ACCOUNT_CREDITS_ROUTE_NAME
}

export function getAccountCreditsRouteRecord(): RouteRecordRaw {
  return {
    name: 'account_credits',
    path: 'credits',
    component: customAsyncComponent(async () => import('./views/CreditsView.vue')),

    meta: {
      accountNav: true,
      localeCategories: [
        LOCALE_CATEGORIES.JOURNEY,
        LOCALE_CATEGORIES.MY_ACCOUNT,
        LOCALE_CATEGORIES.ERRORS,
      ]
    }
  }
}

export function getAccountCreditsRouteLocation(workspaceId: WorkspaceId): RouteLocationRaw {
  return {name: 'account_credits', params: {workspaceId}}
}

export function getAccountCreditsRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}